import React, { useState, useEffect, useRef } from 'react'
import api from '../../services/api'
import './video.css'

export default function VideoPlayer({url, title, subheader, subtitles, handleVideoPlayer}) {
    const apiURL = process.env.REACT_APP_API_URL
    const [language, setLanguage] = useState('en')
    const videoRef = useRef(null)

    useEffect(async () => {
        if(sessionStorage.getItem("language")){
            setLanguage(sessionStorage.getItem("language"))
        } else {
            try{
                const response = await api.get(`/setting`)
                if(response.data){
                    const language = response.data.data.attributes.Language
                    setLanguage(language)
                    sessionStorage.setItem("language", language)
                }
            } catch(err) {
                console.log(err)
            }
        }

        
    }, [])

    const closePlayer = () => {
        const video = videoRef.current
        const tracks = [ ...video.textTracks ]

        if(Array.isArray(tracks) && tracks.length) {
            const active = tracks.find( track => track.mode === "showing" )
            if (active) sessionStorage.setItem("language", active.language)
        }

        handleVideoPlayer(false)
    }

    return (
        <div className="videoPlayer">
            <button className="linksBox__close" onClick={closePlayer}>X</button>
            <div className='videoPlayer__container'>
                <video ref={videoRef} controls autoPlay controlsList="nodownload noplaybackrate" crossOrigin="anonymous">
                    <source src={url} type="video/mp4" />
                    {subtitles && subtitles.map((sub, index) => (
                        <track 
                            className='subs'
                            key={index}
                            label={sub.Label} 
                            kind="captions" 
                            srcLang={sub.Language} 
                            src={apiURL + sub.VTT.data.attributes.url} 
                            default={language === sub.Language}
                        ></track>
                    ))}
                    Your browser does not support the video tag.
                </video>

                {title && (
                    <h3>{title}</h3>
                )}

                {subheader && (
                    <h4>{subheader}</h4>
                )}
            </div>
        </div>
    )
}